<template>
  <div id="app" class="web-app" :class="{'show': logined}">
    <header-bar :visible="logined"></header-bar>
    <!-- <login-box :visible="loginModel"></login-box> -->
    <qr-code-login-box :visible="loginModel"></qr-code-login-box>
    <reg-box :visible="regModel"></reg-box>
    <!-- <side-bar></side-bar> -->
    <alerts></alerts>
    <transition name="bounce"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="mgui-mask" v-show="$store.state.maskShow"></div>
    </transition>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <message-board :visible.sync="boardVisible" v-if="logined"></message-board>
    <!-- <Spin v-if="$store.state.loadingState" fix>
      <Icon type="ios-loading" size='40' class="spin-icon-load"></Icon>
      <div>请稍等</div>
    </Spin> -->
  </div>
</template>

<script>
import {fetch} from './fetch/api'

export default {
  name: 'app',
  components: {
    QrCodeLoginBox: resolve => { require(['./components/QrCodeLoginComponent'], resolve) },
    MessageBoard: resolve => { require(['./components/MessageBoardComponent'], resolve) },
    RegBox: resolve => { require(['./components/RegisterComponent'], resolve) },
    HeaderBar: resolve => { require(['./components/HeaderComponent'], resolve) },
    Alerts: resolve => { require(['./components/AlertsComponent'], resolve) }
  },
  data () {
    return {
      scrollTop: 0,
      isHold: false,
      isFetchCount: true,
      dataList: 50,
      loading: false,
      logined: false,
      loginModel: false,
      regModel: false,
      spinShow: true,
      boardVisible: false
    }
  },
  watch: {
    // 'scrollTop': function (val) {
    //   this.headerHolder(val)
    // },
    '$store.state.logined' () {
      this.loginState()
    }
  },
  mounted () {
    // var scrollPosition = 0
    // var ticking = false
    // let t = this
    // let token = localStorage.getItem('token')
    // if (token) this.$store.dispatch('setToken', token)

    this.loginState()
    // window.addEventListener('scroll', function (e) {
    //   scrollPosition = window.scrollY
    //   if (!ticking) {
    //     window.requestAnimationFrame(function () {
    //       t.scrollTop = scrollPosition
    //       ticking = false
    //     })
    //   }
    //   ticking = true
    // })
  },
  methods: {
    headerHolder (scrollTop) {
      // let header = document.querySelector('.web-header')
      this.isHold = scrollTop > 90
    },
    fetchMessageCount () {
      fetch('console/message_count/0').then(res => {
        if (res.status === 'ok') {
          this.$store.dispatch('setBadge', {key: 'message', 'value': res.count})
        }
      })
    },
    fetchCount () {
      fetch('users/badge/count').then(res => {
        if (res.status === 'ok') {
          this.$store.dispatch('setBadge', {key: 'entry', 'value': res.count.entry})
          this.$store.dispatch('setBadge', {key: 'reg', 'value': res.count.reg})
          this.$store.dispatch('setBadge', {key: 'leave', 'value': res.count.leave})
          this.$store.dispatch('setBadge', {key: 'quit', 'value': res.count.quit})
          this.$store.dispatch('setBadge', {key: 'ask', 'value': res.count.ask})
          this.$store.dispatch('setBadge', {key: 'expense', 'value': res.count.expense})
        }
      })
    },
    loginState () {
      setTimeout(() => {
        if (this.$store.state.logined) {
          this.loginModel = false
          this.regModel = false
          this.logined = true
          this.$store.state.loadingState = false
          if (this.isFetchCount) {
            if (this.$socket) this.$socket.emit('join', this.$store.state.userInfo.username, 'hall', this.$store.state.userInfo.id)
            this.isFetchCount = false
            // 消息统计
            this.fetchMessageCount()
            // 审核统计
            if (this.$menu.isPower('user', 'check')) this.fetchCount()
            setTimeout(() => {
              this.isFetchCount = true
            }, 1000)
          }
          if (this.$store.state.userInfo.entry_status < 2 && this.$router.path !== '/entry') {
            this.$router.replace({'path': '/entry'})
          }
        } else {
          this.loginModel = true
          this.logined = false
          this.$store.state.loadingState = false
          if (this.$route.query.debug === 'true' && !this.$store.state.logined) {
            this.loginModel = false
            this.regModel = true
          }
        }
      }, 1000)
    }
  }
}
</script>

<style>
  html,body{
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif !important;
    margin: 0;
    background-color: #f1f1f1 !important;
    min-height: 100%;
  }
  body{
    overflow-x: auto;
  }
  ul,li{list-style: none;margin:0;padding:0;}
  *{box-sizing: border-box}
  .web-app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100%;
  }
  h1,h2,h3,h4,h5,h6{margin:0;padding:0;font-weight: normal;}
  h1{font-size:22px;}
  h2{font-size:20px;}
  h3{font-size:18px;}
  h4{font-size:16px;}
  h5{font-size:14px;}
  h6{font-size:12px;}
  a{text-decoration:none;}
  .nodata{text-align: center;color:#999;padding:20px;}
  .icon {
     width: 1em; height: 1em;
     vertical-align: -0.15em;
     fill: currentColor;
     overflow: hidden;
  }
  .web-app .ivu-table-fixed-header thead tr th{
    height: 40px;
    padding:0
  }
  .flex{
    display: flex;
  }
  .flex-1{
    flex: 1;
  }
  .filter-row{
    border: 1px solid #eaeaea;
    background: #f7f7f7;
    padding:8px;
    margin:-10px 0 15px;
    border-radius: 6px;
  }
  .filter-row .ivu-col-span-xs-24:last-child>div{margin-left:5px}
  .filter-row-item>div{margin-right: 5px}
  .filter-row .badge{background:#f00;color:#fff;border-radius: 8px;padding:0 5px;margin-left:5px !important}
  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  .mgui-container{
    padding: 20px;
  }
  .clearfix:after{
    content: '';
    display: block;
    clear: both;
  }
  .col-tip{
    position: relative;
  }
  .col-tip .ivu-poptip-popper,.col-tip .ivu-tooltip-popper{
    position: absolute !important;
  }
  .organiz-tree .ivu-poptip-popper{position: absolute !important;}
  .ivu-tabs-tabpane .ivu-select-dropdown{
    position: absolute !important;
  }
  .ivu-tree>.ivu-tree-children{border-bottom:1px solid #eee;min-height: 50px}
  .ivu-tree-inner .ivu-tree ul li{white-space: normal;}
  .ivu-tree-inner .ivu-tree>.ivu-tree-children>li{padding-left:100px;}
  .ivu-tree-inner .ivu-tree>.ivu-tree-children>li>span.ivu-tree-title{position: absolute;left:40px;}
  .ivu-tree-inner .ivu-tree>.ivu-tree-children>li>label.ivu-checkbox-wrapper{position: absolute;left:25px;}
  .ivu-tree-inner .ivu-tree>.ivu-tree-children>li>span.ivu-tree-arrow{position: absolute;left:10px;}
  .mobile-show{display: none;}
  .block-center{float:none;margin:0 auto;}
  .mgui-row-col.block-center{float:none;}
  .divider{background:#ccc;margin:20px 0;height:1px;}
  .mgui-mask{background-color: rgba(0,0,0,.4);position: fixed;top:0;left:0;width:100%;height:100%;z-index:998;}
  /* .div-table-head */
  .div-table-head{
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    /*background-color: #f1f1f1*/
  }
  .div-table-body .ivu-row{
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    font-size:12px
  }
  .div-table-body .ivu-row .ivu-row{border:none;padding:0;;}
  .ivu-col-xs-float-right{float:right;width: auto;}
  .center{text-align: center;}
  .icon {
   width: 1em; height: 1em;
   vertical-align: -0.15em;
   fill: #333;
   overflow: hidden;
  }
  .pager{padding:20px 0;text-align: center}
  .loading-state{text-align: center;font-size:14px;}
  .spin-icon-load{
      animation: ani-spin 1s linear infinite;
  }
  .show .apps-icon-navs .nav-link.hidden{
    display: none;
  }
  .show .apps-icon-navs .nav-link.debug{
    display: block;
  }
  .animated {
    animation-duration: .3s;
  }
  /* 日历 */
  .cal-header .icon {
    overflow: visible;
  }
  @keyframes ani-spin {
      from { transform: rotate(0deg);}
      50%  { transform: rotate(180deg);}
      to   { transform: rotate(360deg);}
  }
  .rotate{
    animation: rotate-in 2s linear infinite;
    -webkit-animation: rotate-in 2s linear infinite;
  }

  @keyframes rotate-in {
    0% {
      transform: rotate(0);
    }
    /*50% {
      transform: rotate(180deg);
    }*/
    100% {
      transform: rotate(360deg);
    }
  }
  @media (min-width: 640px) {
    .ivu-tree-inner .ivu-tree-children>li>.ivu-tree-children{display: inline-block}
    .ivu-tree-inner .ivu-tree-children>li>.ivu-tree-children>li{margin:0;}
  }
  @media (max-width: 640px) {
    .filter-row{
      padding:10px;
      /*margin:-20px -20px 15px;*/
    }
    .mobile-show{
      display: inherit;
    }
    .mobile-hide{
      display: none !important;
    }
  }
</style>
